import { render, staticRenderFns } from "./LegalAccountingBuilding.vue?vue&type=template&id=2a3d5632&scoped=true&"
import script from "./LegalAccountingBuilding.vue?vue&type=script&lang=js&"
export * from "./LegalAccountingBuilding.vue?vue&type=script&lang=js&"
import style0 from "./LegalAccountingBuilding.vue?vue&type=style&index=0&id=2a3d5632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3d5632",
  null
  
)

export default component.exports